import { AnalysisType, Chart, ComponentConfiguration } from '@/interfaces/common';
import { Module } from 'vuex';

const defaultState = {
    chartControleAnalyses: [],
};

const defaultChart: Chart = {
    actions: [],
    analysisType: '',
    analyticProcedure: '',
    siteControlled: undefined,
    analysis: null,
};

export interface ControlChartState {
    chartControleAnalyses: Chart[];
}

const controlChart: Module<ControlChartState, unknown> = {
    state: () => ({ ...defaultState }),

    mutations: {
        setChartControleAnalyses(state, analyses: ComponentConfiguration[]) {
            state.chartControleAnalyses = analyses.map((analyse) => {
                return {
                    ...defaultChart,
                    analysisType: (analyse.analysisType as AnalysisType).id,
                    analysis: analyse,
                };
            });
        },
        clearAnalyses(state) {
            state.chartControleAnalyses = [];
        },
    },
    getters: {
        chartControleAnalyses: (state) => state.chartControleAnalyses,
    },
};

export default controlChart;
